import { IonContent } from '@ionic/react';
import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  MainImgStyles,
  ScreenStyles,
  PageTitleStyles,
  SubtitleStyles,
  ContentContainerStyles,
} from './WelcomeScreen.styles';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Gender',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <ScreenStyles background="dark-solid">
      <IonContent scrollY={false}>
        <LogoWithAppName withCaption={false} />
        <MainImgStyles>
          <img
            src={`${S3_BUCKET_URL}/own-ai-roleplay-rooms/welcome/characters.png`}
            alt="Characters"
          />
        </MainImgStyles>
        <ContentContainerStyles>
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Roleplay Rooms
            <SubtitleStyles variant={'body-medium'}>
              Step into a world where your fantasy
              <br /> comes alive.
            </SubtitleStyles>
          </PageTitleStyles>
          <OnboardingFooter
            buttonSize={'large'}
            buttonRadius="md"
            onContinue={handleNextStep}
            buttonText={'Choose my perfect setting'}
          />
        </ContentContainerStyles>
      </IonContent>
    </ScreenStyles>
  );
};
